import { TeamsUserCredential } from '@microsoft/teamsfx';
import { createContext } from 'react';
import { Theme } from '@fluentui/react-components';

export const TeamsFxContext = createContext<{
  theme?: Theme;
  themeString: string;
  teamsUserCredential?: TeamsUserCredential;
  isMobile: boolean;
  isMobileOnly: boolean;
  currentUserEmail: string;
  appHost: string;
}>({
  theme: undefined,
  themeString: '',
  teamsUserCredential: undefined,
  isMobile: false,
  isMobileOnly: false,
  currentUserEmail: '',
  appHost: '',
});
